import * as Yup from "yup";

const nfSaidaItemUpdateImposto = Yup.object().shape({
  ncmCodigo: Yup.string().required("Ncm Código"),
  ncmId: Yup.string().required("Ncm"),
  tributosIcmsCsosn: Yup.string().when("isCombustivel", {
    is: false,
    then: Yup.string().nullable().required("CSO"),
    otherwise: Yup.string().nullable(),
  }),
  tributosIcmsCst: Yup.string().when("isCombustivel", {
    is: true,
    then: Yup.string().nullable().required("CST"),
    otherwise: Yup.string().nullable(),
  }),
  cfop: Yup.string().required("Cfop"),
});

const nfSaidaItensUpdateImposto = Yup.array().of(nfSaidaItemUpdateImposto);

export { nfSaidaItemUpdateImposto, nfSaidaItensUpdateImposto };
